import { takeLatest, call, put } from 'redux-saga/effects';
import { getSignature, getSelectedCars, sendSignature } from 'api';

import { showLoadScreen, hideLoadScreen } from 'components/LoadScreen/actions';
import * as actions from './actions';

function* getHandl() {
  try {
    const result = yield call(getSelectedCars);
    const signatureData = yield call(getSignature, result.data[0].carId);
    yield put(actions.setSignature(signatureData.data.car, signatureData.data.name));
  } catch (err) {
    console.log('ERR', err);
  }
}

function* sendHandl(action) {
  const { payload: { callback, name, isEmail } } = action;

  try {
    yield put(showLoadScreen());
    yield call(sendSignature, name, isEmail);

    if (callback) callback();
    yield put(hideLoadScreen());
  } catch (err) {
    console.log('ERR', err);
    yield put(hideLoadScreen());
  }
}


export default function* () {
  yield takeLatest(
    actions.GET_SIGNATURE,
    getHandl
  );
  yield takeLatest(
    actions.SEND_SIGNATURE,
    sendHandl
  );
}



// WEBPACK FOOTER //
// ./src/pages/Signature/saga.js